import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

document.documentElement.setAttribute('data-bs-theme', 'dark')
document.documentElement.style.colorScheme = 'dark'

import 'bootstrap/dist/css/bootstrap.min.css'
import '@/styles/bootstrap-dark.css'
import '@fortawesome/fontawesome-free/css/fontawesome.min.css'
import '@fortawesome/fontawesome-free/css/solid.min.css'
import '@fortawesome/fontawesome-free/css/brands.min.css'
import '@/styles/main.css'

createApp(App).use(router).mount('#app')